// extracted by mini-css-extract-plugin
export default {"arrowWrapper":"style_arrowWrapper__kvtr5","wrapper":"style_wrapper__2Sh6s","backgroundImage":"style_backgroundImage__OAY2Z"};